import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsConditionsPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="terms-conditions-page">
      {/* Header */}
      <section className="py-12 md:py-16 bg-[#2E5C31]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 text-white">
          <Link to="/" className="inline-flex items-center text-white/80 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold font-['Poppins']">Terms & Conditions</h1>
          <p className="text-gray-200 mt-2">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="policy-content prose prose-lg">
            <h2>Agreement to Terms</h2>
            <p>
              By accessing or using the services of DecorVista Landscaping Services ("Company," "we," "us," or "our"), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not use our services.
            </p>

            <h2>Services</h2>
            <p>
              DecorVista provides landscaping services including but not limited to lawn installation, landscape design, hardscape installation, irrigation systems, seasonal cleanup, and tree/shrub trimming for residential properties in the Seattle, WA area.
            </p>

            <h2>Service Estimates</h2>
            <ul>
              <li>All estimates are provided free of charge and are valid for 30 days from the date issued</li>
              <li>Estimates are based on information provided and initial site assessment</li>
              <li>Final pricing may vary if site conditions differ from initial assessment</li>
              <li>Written estimates will detail scope of work, materials, and pricing</li>
            </ul>

            <h2>Service Agreement</h2>
            <p>Upon acceptance of an estimate:</p>
            <ul>
              <li>A service agreement must be signed by the property owner or authorized representative</li>
              <li>A deposit may be required before work begins (amount specified in agreement)</li>
              <li>Work schedule will be agreed upon and confirmed in writing</li>
            </ul>

            <h2>Payment Terms</h2>
            <ul>
              <li>Payment methods accepted: Check, Credit Card, Bank Transfer</li>
              <li>Deposit requirements vary by project scope</li>
              <li>Final payment is due upon completion of work</li>
              <li>Late payments may incur additional fees as specified in the service agreement</li>
            </ul>

            <h2>Property Access</h2>
            <p>By engaging our services, you agree to:</p>
            <ul>
              <li>Provide safe and reasonable access to the work area</li>
              <li>Inform us of any underground utilities, sprinkler systems, or other hazards</li>
              <li>Secure pets during work hours</li>
              <li>Remove personal items from the work area</li>
            </ul>

            <h2>Warranties</h2>
            <ul>
              <li>Workmanship warranty: 1 year from completion date</li>
              <li>Plant warranty: Subject to terms specified in service agreement</li>
              <li>Warranties do not cover damage from weather, neglect, or third parties</li>
            </ul>

            <h2>Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, DecorVista shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from the use of our services.
            </p>

            <h2>Force Majeure</h2>
            <p>
              We shall not be liable for delays or failure to perform due to circumstances beyond our reasonable control, including but not limited to weather conditions, natural disasters, or government actions.
            </p>

            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website.
            </p>

            <h2>Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of Washington.
            </p>

            <h2>Contact Information</h2>
            <p>For questions about these Terms and Conditions:</p>
            <ul>
              <li><strong>Business Name:</strong> DecorVista Landscaping Services</li>
              <li><strong>Address:</strong> 667 Harbor View Drive, Seattle, WA 98101</li>
              <li><strong>Phone:</strong> +1-888-880-8889</li>
              <li><strong>Email:</strong> support@decorvista.store</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditionsPage;
